// ==================== src/api/system/index.ts ====================
import { systemEmailApi } from './email';
import { systemUserApi } from './user';
import { systemBindingApi } from './binding';
import { systemPointsApi } from './points';
import { systemGiftPointsConfigApi } from './giftPointsConfig';

// 细粒度导出：类型 + 子 API 对象
export * from './email';
export * from './user';
export * from './binding';
export * from './points';
export * from './giftPointsConfig';

/**
 * 系统模块聚合 API。
 * <p>整合 Email / User / Binding / Points 四个 Controller 的方法，
 * 便于桥接层一次性重建原 userApi 的全部方法。
 */
export const systemApi = {
  ...systemEmailApi,
  ...systemUserApi,
  ...systemBindingApi,
  ...systemPointsApi,
  ...systemGiftPointsConfigApi,
};